import { render, staticRenderFns } from "./CustomersPanel.vue?vue&type=template&id=f5c53d1c&scoped=true&"
import script from "./CustomersPanel.vue?vue&type=script&lang=ts&"
export * from "./CustomersPanel.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersPanel.vue?vue&type=style&index=0&id=f5c53d1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c53d1c",
  null
  
)

export default component.exports